const GREETING = /^(hi|hello|hey|dear|good (morning|afternoon|evening)|hej|hallo|moin|bonjour|goedemiddag|beste)\b[^,!\n]{0,40}[,!]\s*/i;

const BARE_NAME = /^\p{Lu}[\p{L}'-]*(\s\p{Lu}[\p{L}'-]*)?,\s+(?=\p{Lu})/u;

/**
 * The preview text of a row: the first meaningful words of a message, without quoted lines or a
 * leading greeting ("Hi Adam,", "Dear Mr Albastov,"). Works on a full body or a one line snippet.
 */
export function snippetOf(text: string | null | undefined): string {
  const body = (text ?? '')
    .split('\n')
    .map((l) => l.trim())
    .filter((l) => l.length > 0 && !l.startsWith('>'))
    .join(' ');
  let rest = body;
  // Greetings can repeat ("Hi Tom, hi Gareth,") or be a bare name ("Adam, The deposit...").
  for (let prev = ''; prev !== rest; ) {
    prev = rest;
    rest = rest.replace(GREETING, '').replace(BARE_NAME, '');
  }
  return (rest || body).replace(/\s+/g, ' ').trim();
}
